<!-- <div class="container mt-5">
    <h2 class="text-center mb-4">Compare Our Packages</h2>

    <div class="table-responsive">
        <table
            class="table text-center align-middle package-table table-striped-custom dataTable table-hover no-footer">
            <thead>
                <tr>
                    <th class="text-start. bg-primary text-white">Features</th>
                    <th *ngFor="let pkg of packages" class="bg-primary text-white">{{ pkg.name }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="text-start fw-semibold oddRow">Plan Image</td>
                    <td class="oddRow" *ngFor="let pkg of packages">
                        <img [src]="pkg.image" alt="Plan Image"
                            style="width: 80px; height: auto; border-radius: 4px;" />
                    </td>
                </tr>

                <tr>
                    <td class="text-start fw-semibold evenRow">Price</td>
                    <td class="evenRow" *ngFor="let pkg of packages">
                        <span style="font-weight: bold;">{{ setFormat(pkg.total) }}</span>

                        <span *ngIf="pkg.amount !== pkg.total"
                            style="margin-left: 5px; text-decoration: line-through; color: gray;">
                            {{ setFormat(pkg.amount) }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td class="text-start fw-semibold oddRow">No. of Users</td>
                    <td class="oddRow" *ngFor="let pkg of packages">{{ pkg.totalUsers }}</td>
                </tr>
                <tr>
                    <td class="text-start fw-semibold evenRow">No. of Courses</td>
                    <td class="evenRow" *ngFor="let pkg of packages">{{ pkg.noOfCourse }}</td>
                </tr>
                <tr>
                    <td class="text-start fw-semibold oddRow">Description</td>
                    <td class="oddRow" *ngFor="let pkg of packages">{{ pkg.description }}</td>
                </tr>
                <tr>
                    <td class="text-start fw-semibold evenRow">No. of Audit</td>
                    <td class="evenRow" *ngFor="let pkg of packages">{{ pkg.noOfAudit }}</td>
                </tr>
                <tr>
                    <td class="text-start fw-semibold oddRow">No. of Equipment Certificates</td>
                    <td class="oddRow" *ngFor="let pkg of packages">{{ pkg.noOfEquipmentCertificates }}</td>
                </tr>
                <tr>
                    <td class="text-start fw-semibold evenRow">SOS Safety Seminars</td>
                    <td class="evenRow" *ngFor="let pkg of packages">{{ pkg.sosSafetySeminars }}</td>
                </tr>
                <tr>
                    <td class="text-start fw-semibold oddRow">OSHA Session</td>
                    <td class="oddRow" *ngFor="let pkg of packages">{{ pkg.oshaSession }}</td>
                </tr>
                <tr>
                    <td></td>
                    <td *ngFor="let pkg of packages">
                        <button class="btn btn-outline-primary w-100" (click)="choosePackage(pkg)">Choose</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div> -->

<div class="mt-4">
  <h2 class="text-center mb-4">Service Packages</h2>

  <div class="row">
    <div class="col-md-3 col-sm-6 mb-4" *ngFor="let pkg of packages">
      <div class="card border-0 shadow-sm">
        <!-- Package Poster Image -->
        <img [src]="pkg.poster"
             alt="{{ pkg.name }}"
             class="card-img-top"
             style="height: 600px; object-fit: cover; border-radius: 8px;" />

        <!-- Choose Button -->
        <div class="card-body">
          <button class="btn btn-outline-primary w-100" (click)="choosePackage(pkg)">Choose</button>
        </div>
      </div>
    </div>
  </div>
</div>

